var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_1346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 30.5C13.6284 30.5 14.3 31.1716 14.3 32V54.5H49.7V32C49.7 31.1716 50.3715 30.5 51.2 30.5C52.0284 30.5 52.7 31.1716 52.7 32V56C52.7 56.8284 52.0284 57.5 51.2 57.5H12.8C11.9716 57.5 11.3 56.8284 11.3 56V32C11.3 31.1716 11.9716 30.5 12.8 30.5Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 20C6.5 19.1716 7.17157 18.5 8 18.5H56C56.8284 18.5 57.5 19.1716 57.5 20V32C57.5 32.8284 56.8284 33.5 56 33.5H8C7.17157 33.5 6.5 32.8284 6.5 32V20ZM9.5 21.5V30.5H54.5V21.5H9.5Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 18.5C32.8284 18.5 33.5 19.1716 33.5 20V56C33.5 56.8284 32.8284 57.5 32 57.5C31.1716 57.5 30.5 56.8284 30.5 56V20C30.5 19.1716 31.1716 18.5 32 18.5Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 9.5C20.0065 9.5 18.8619 9.97411 18.018 10.818C17.1741 11.6619 16.7 12.8065 16.7 14C16.7 15.1935 17.1741 16.3381 18.018 17.182C18.8619 18.0259 20.0065 18.5 21.2 18.5H30.039C29.7012 17.4461 29.1809 16.0779 28.4357 14.7229C26.8735 11.8825 24.5659 9.5 21.2 9.5ZM32 20C33.4709 19.7058 33.4708 19.7053 33.4707 19.7047L33.4697 19.6997L33.4675 19.6893L33.4605 19.6555C33.4545 19.6273 33.446 19.588 33.4349 19.5383C33.4127 19.4389 33.38 19.2976 33.3357 19.1206C33.2472 18.7667 33.1124 18.268 32.9238 17.6722C32.5481 16.486 31.9506 14.8885 31.0643 13.2771C29.3265 10.1175 26.2342 6.5 21.2 6.5C19.2109 6.5 17.3032 7.29018 15.8967 8.6967C14.4902 10.1032 13.7 12.0109 13.7 14C13.7 15.9891 14.4902 17.8968 15.8967 19.3033C17.3032 20.7098 19.2109 21.5 21.2 21.5H32C32.4494 21.5 32.8751 21.2985 33.16 20.951C33.4449 20.6034 33.559 20.1465 33.4709 19.7058L32 20Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9357 13.2771C34.6735 10.1175 37.7658 6.5 42.8 6.5C44.7891 6.5 46.6968 7.29018 48.1033 8.6967C49.5098 10.1032 50.3 12.0109 50.3 14C50.3 15.9891 49.5098 17.8968 48.1033 19.3033C46.6968 20.7098 44.7891 21.5 42.8 21.5H32C31.5506 21.5 31.1249 21.2985 30.84 20.951C30.5551 20.6034 30.441 20.1465 30.5291 19.7058L32 20C30.5291 19.7058 30.5292 19.7053 30.5293 19.7047L30.5296 19.7033L30.5304 19.6997L30.5325 19.6893L30.5395 19.6555C30.5455 19.6273 30.554 19.588 30.5651 19.5383C30.5873 19.4389 30.62 19.2976 30.6643 19.1206C30.7528 18.7667 30.8876 18.268 31.0762 17.6722C31.4519 16.486 32.0494 14.8885 32.9357 13.2771ZM33.9611 18.5H42.8C43.9935 18.5 45.1381 18.0259 45.982 17.182C46.8259 16.3381 47.3 15.1935 47.3 14C47.3 12.8065 46.8259 11.6619 45.982 10.818C45.1381 9.97411 43.9935 9.5 42.8 9.5C39.4341 9.5 37.1265 11.8825 35.5643 14.7229C34.8191 16.0779 34.2988 17.4461 33.9611 18.5Z",
    fill: "#11216C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.501cd23e17bce212480673d831880cb3.svg";
export { ForwardRef as ReactComponent };